import { useMutation, useQuery } from "@apollo/client";
import { useLocation } from "react-router-dom";

import { Button } from "../../../../components/ui";
import { LIST_TYPES } from "../../../../constants/listTypes";
import { CREATE_LIST } from "../../../../graphql/mutation/List";
import { FETCH_LISTS as fetchLists } from "../../../../graphql/query/List";
import { FETCH_LIST_ITEMS as fetchListItems } from "../../../../graphql/query/ListItems";
import { buildInstanceSelectListInput } from "./instanceSelectListInput";

const AddInstancePrimaryImageToSelectList = props => {
  const { closeModal, imageListId, imageWorkingListId } = props || {};
  const selectionInput = buildInstanceSelectListInput({
    ...props,
    images: true,
    primary: true,
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const imageListIdFromUrl = queryParams.get("imageListId");
  const imageWorkingListIdFromUrl = queryParams.get("imageWorkingListId");
  const getNumericListId = value => {
    const parsedValue = +value;
    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
  };
  const { data: { lists: { edges = [] } = {} } = {} } = useQuery(fetchLists(), {
    variables: {
      input: { typeId: LIST_TYPES.INSTANCE_IMAGE_WORKING },
    },
    fetchPolicy: "network-only",
  });
  const fallbackWorkingListId = getNumericListId(edges?.[0]?.id);
  const targetListId =
    getNumericListId(imageListId) ||
    getNumericListId(imageListIdFromUrl) ||
    getNumericListId(imageWorkingListId) ||
    getNumericListId(imageWorkingListIdFromUrl) ||
    fallbackWorkingListId;
  const [createList, { loading }] = useMutation(CREATE_LIST(), {
    refetchQueries: [
      {
        query: fetchLists(),
        variables: { input: {} },
        fetchPolicy: "network-only",
      },
      {
        query: fetchListItems(),
        variables: { input: {} },
        fetchPolicy: "network-only",
      },
    ],
    awaitRefetchQueries: true,
  });

  const handleClick = () => {
    if (!targetListId || !selectionInput) {
      return;
    }

    createList({
      variables: {
        input: {
          listId: targetListId,
          ...selectionInput,
          primary: true,
        },
      },
    }).then(resp => {
      const { data: { createList: { success } = {} } = {} } = resp;

      if (success) {
        closeModal();
      }
    });
  };

  return (
    <div className="flex flex-col">
      <div>
        <Button
          action="default"
          className="mr-4"
          label="Cancel"
          onClick={() => {
            closeModal();
          }}
        />
        <Button
          label={loading ? "Adding" : "Add"}
          disabled={loading || !targetListId || !selectionInput}
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

export default AddInstancePrimaryImageToSelectList;
